import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAuth } from "contexts/AuthContext";
import { BIM } from "utils/bim";

type UseDeleteBIMMutationVariablesPayload = {
  id: string;
}

const useDeleteBIMMutation = (projectId: string) => {
  const { authApi } = useAuth();
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: async (payload: UseDeleteBIMMutationVariablesPayload) => {
      const { data } = await authApi.delete<BIM>(`/bim/${payload.id}`);
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["bims", projectId],
      });
    },
  });
};

export default useDeleteBIMMutation;
